import { serviceRouteConstants } from "@/Constants/routingConstants";

import { postFormData } from ".";
/**
 * Function to retrieve notification history.
 *
 * @param {Object} data - The data to be sent in the request
 * @return {Promise} The result of the post request
 */
export const _clientReportFeedbackCollection = async (data) => {
  let formData = new FormData();
  formData.append("feedback_type", data.feedback_type);
  formData.append("module_name", data.module_name);
  formData.append("description", data.description);
  formData.append("feedback_file", data.feedback_file);

  return postFormData(serviceRouteConstants.clientReportFeedback, formData);
};
